module.exports = {"es":{"message":{"hello":"hola mundo!"}}}


//////////////////
// WEBPACK FOOTER
// ./static/locales/es.json
// module id = 674
// module chunks = 8